module.exports = __webpack_public_path__ + "static/img/login-bg-ga.74777ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/login-bg-ga.jpg
// module id = sdhZ
// module chunks = 1